<template>
    <div id="datatable-receivers-backoffice">
        <v-data-table
            :headers="headers"
            :items="list"
            :hide-default-footer="true"
            dense
            disable-pagination
            class="table-striped"
        >
            <template v-slot:[`item.actions`]="{ item }">
                <v-checkbox v-model="item.checked" class="small-checkbox" />
            </template>
        </v-data-table>
    </div>
</template>

<script>
export default {
    props: {
        list: Array | Object,
    },
    computed: {
        headers() {
            return [
                {
                    text: "",
                    align: "start",
                    value: "actions",
                    width: "5%",
                    class: "header-table-color",
                    sortable: false,
                },
                {
                    text: this.$t("backoffice.modules.request-manager.name"),
                    align: "start",
                    value: "name",
                    class: "header-table-color",
                    sortable: false,
                },
            ];
        },
    },
};
</script>

<style lang="scss">
@import "@sass/_variables.scss";
#datatable-receivers-backoffice {
    tr {
        height: 42px;
    }

    .small-checkbox {
        margin-top: 0;
        max-height: 30px;
    }
}
</style>
